module.exports = __webpack_public_path__ + "img/icon-close@3x.1e3e9c9b.png";